import { Quote } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import OptimizedImage from "../../../utils/landing/OptimizedImage";

export function TestimonialsSection() {
  const testimonials = [
    {
      quote: "La I.E.P San Isidro de Zaña, es la primera institución privada de mi querido Zaña, es una institución que impone disciplina, valores, respeto además de tener una plana docente comprometida con la enseñanza de nuestros hijos e hijas con un nivel academico que no tiene nada que envidiar a otra privada, para mí el mejor colegio de Zaña. Que resalta por su enseñanza, valores, disciplina, logros en los desfiles escolares y  concursos ganados..",
      author: "Flor Rosalina Escobar Lara",
      image: "/img/landing/testimonio1.webp"
    },
    {
      quote: "Elegir el colegio de nuestros hijos es la decisión más importante, y en la I.E.P San Isidro encontré la tranquilidad que buscaba. No solo por la formación integral, sino porque los resultados hablan por sí solos: ¡es el colegio privado con el mayor índice de ingresantes a la prestigiosa Universidad Nacional Pedro Ruiz Gallo en todo el valle de Zaña! Orgullosa de ver cómo se preparan para los grandes reto.",
      author: "Mayra Burga Colchado",
      image: "/img/landing/testimonio2.webp"
    },
    {
      quote: "Recomiendo con mucho agrado al colegio San Isidro, institución de la cual fui alumna y donde actualmente estudian mis dos hijos. Es un colegio que promueve valores cristianos, formando no solo buenos estudiantes, sino también excelentes personas. Destaco su compromiso con la educación integral, fomentando la competitividad sana, la responsabilidad y el respeto. Sin duda, es una excelente opción para la formación académica y personal de los niños.",
      author: "Francys Núñez",
      image: "/img/landing/testimonio3.webp"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-custom mb-4">Lo que dicen nuestras familias</h2>
          <div className="w-24 h-1 bg-primary-custom mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Descubre las experiencias de nuestras familias y cómo San Isidro ha impactado positivamente en la educación de sus hijos.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index} 
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 relative overflow-hidden group"
            >
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="relative">
                    <div className="absolute -top-4 -left-4 text-primary-custom/20 group-hover:text-primary-custom/30 transition-colors duration-300">
                      <Quote className="w-8 h-8" />
                    </div>
                    <div className="relative w-20 h-20 rounded-full overflow-hidden ring-4 ring-primary-custom/10 group-hover:ring-primary-custom/20 transition-all duration-300">
                      <OptimizedImage 
                        src={testimonial.image} 
                        alt={testimonial.author} 
                        fill 
                        className="object-cover transform group-hover:scale-110 transition-transform duration-300" 
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-gray-700 italic mb-6 relative">
                      &quot;{testimonial.quote}&quot;
                    </p>
                    <h4 className="font-semibold text-primary-custom text-lg">{testimonial.author}</h4>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
